<template>
    <el-container>
      <el-aside width="300px">
        <div><el-input
          placeholder="输入关键字"
          v-model="filterText">
        </el-input></div>
      <div style="height:600px;margin-top: 10px;overflow-y: scroll">
        <el-tree
          class="filter-tree"
          :data="treeDate"
          :props="defaultProps"
          node-key="id"
          default-expand-all
          :filter-node-method="filterNode"
          show-checkbox
          ref="tree">
        </el-tree>
      </div>
        <div><el-button @click="getCheckedNodes" style="float: right">播放</el-button></div>
      </el-aside>
      <el-main style="overflow-y: hidden">
        <div style="height: 580px">
          <div style="margin-top: 20px">
            <el-select v-model="camWin" @change="reset">
              <el-option v-for="item in winSize" :label="item.size" :value="item.num"></el-option>
            </el-select>
            <span>
            <el-radio v-model="radio" label="1">流畅</el-radio>
            <el-radio v-model="radio" label="2">高清</el-radio>
          </span>
          </div>
          <!--        <div id="video-container" style="width: 1200px;height: 450px;background-color: black"></div>-->
          <!--        <div v-show="camWin==1">-->
          <!--          <span>{{pointName[0]+":"}}</span>-->
          <!--        </div>-->
          <div v-show="camWin==1" style="width: 100%;height: 100%">
            <span style="height: 100%">{{pointName[0]}}</span>
            <div id="video-container" style="width: 100%;height: 100%;background-color: black"></div>
          </div>


          <div v-show="camWin==2" style="width: 100%;height: 100%;margin-top: 20px">
            <div style="width: 100%;height: 40%">
              <div style="height:100%;width:40%;float: left">
                <span style="height: 100%">{{pointName[0]}}</span>
                <div id="video-container11" style="width: 100%;height: 100%;background-color: black"></div>
              </div>
              <div style="height:100%;width:40%;float: left;margin-left: 20px">
                <span style="height: 100%">{{pointName[1]}}</span>
                <div id="video-container12" style="width: 100%;height: 100%;background-color: black"></div>
              </div>
            </div>

            <div style="width: 100%;height: 40%;margin-top: 20px">
              <div style="height:100%;width:40%;float: left">
                <span style="height: 100%">{{pointName[2]}}</span>
                <div id="video-container13" style="width: 100%;height: 100%;background-color: black"></div>
              </div>
              <div style="height:100%;width:40%;float: left;margin-left: 20px">
                <span style="height: 100%">{{pointName[3]}}</span>
                <div id="video-container14" style="width: 100%;height: 100%;background-color: black"></div>
              </div>
            </div>
          </div>


          <div v-show="camWin==3" style="width: 100%;height: 100%;margin-top: 20px">
            <div style="width: 100%;height: 30%">
              <div style="width: 30%;height: 100%;float: left">
                <span style="height: 10px">{{pointName[0]}}</span>
                <div id="video-container1" style="width: 100%;height: 100%;background-color: black"></div>
              </div>
              <div style="width: 30%;height: 100%;margin-left: 10px;float: left">
                <span style="height: 10px">{{pointName[1]}}</span>
                <div id="video-container2" style="width: 100%;height: 100%;background-color: black"></div>
              </div>
              <div style="width: 30%;height: 100%;margin-left: 10px;float: left">
                <span style="height: 10px">{{pointName[2]}}</span>
                <div id="video-container3" style="width: 100%;height: 100%;background-color: black"></div>
              </div>
            </div>
            <div style="width: 100%;height: 30%;margin-top: 20px">
              <div style="width: 30%;height: 100%;float: left">
                <span style="height: 10px">{{pointName[3]}}</span>
                <div id="video-container4" style="width: 100%;height: 100%;background-color: black"></div>
              </div>
              <div style="width: 30%;height: 100%;margin-left: 10px;float: left">
                <span style="height: 10px">{{pointName[4]}}</span>
                <div id="video-container5" style="width: 100%;height: 100%;background-color: black"></div>
              </div>
              <div style="width: 30%;height: 100%;margin-left: 10px;float: left">
                <span style="height: 10px">{{pointName[5]}}</span>
                <div id="video-container6" style="width: 100%;height: 100%;background-color: black"></div>
              </div>
            </div>
            <div style="width: 100%;height: 30%;margin-top: 20px">
              <div style="width: 30%;height: 100%;float: left">
                <span style="height: 10px">{{pointName[6]}}</span>
                <div id="video-container7" style="width: 100%;height: 100%;background-color: black"></div>
              </div>
              <div style="width: 30%;height: 100%;margin-left: 10px;float: left">
                <span style="height: 10px">{{pointName[7]}}</span>
                <div id="video-container8" style="width: 100%;height: 100%;background-color: black"></div>
              </div>
              <div style="width: 30%;height: 100%;margin-left: 10px;float: left">
                <span style="height: 10px">{{pointName[8]}}</span>
                <div id="video-container9" style="width: 100%;height: 100%;background-color: black"></div>
              </div>
            </div>
          </div>

          <!--          <div style="width: 100%;height: 30%" v-show="camWin==3">-->
          <!--            <div id="video-container1" style="height:100%;width:30%;float: left;background-color: black"></div>-->
          <!--            <div id="video-container2" style="height:100%;width:30%;float: left;background-color: black;margin-left: 10px"></div>-->
          <!--            <div id="video-container3" style="height:100%;width:30%;float: left;background-color: black;margin-left: 10px"></div>-->
          <!--          </div>-->
          <!--          <div style="width: 100%;height: 30%;margin-top: 10px" v-show="camWin==3">-->
          <!--            <div id="video-container4" style="height:100%;width:30%;float: left;background-color: black"></div>-->
          <!--            <div id="video-container5" style="height:100%;width:30%;float: left;background-color: black;margin-left: 10px"></div>-->
          <!--            <div id="video-container6" style="height:100%;width:30%;float: left;background-color: black;margin-left: 10px"></div>-->
          <!--          </div>-->
          <!--          <div style="width: 100%;height: 30%;margin-top: 10px" v-show="camWin==3">-->
          <!--            <div id="video-container7" style="height:100%;width:30%;float: left;background-color: black"></div>-->
          <!--            <div id="video-container8" style="height:100%;width:30%;float: left;background-color: black;margin-left: 10px"></div>-->
          <!--            <div id="video-container9" style="height:100%;width:30%;float: left;background-color: black;margin-left: 10px"></div>-->
          <!--          </div>-->

        </div>

      </el-main>
    </el-container>
</template>

<script>
  import EZUIKit from 'ezuikit-js'

  export default {
    name: 'realTimeMonitoring',
    data(){
      return{
        radio:'1',
        pointName:['警报点名称','警报点名称','警报点名称','警报点名称','警报点名称','警报点名称','警报点名称','警报点名称','警报点名称'],
        checkList:[],
        filterText:'',
        camWin:2,
        winSize:[{"size":'1*1',"num":1},{"size":'2*2',"num":2},{"size":'3*3',"num":3},],
        treeDate:[{"id":"","label":"","children":[]}],
        getPreviewURL:{
          "version": '1',
          "method": "camera.GetCameraEzopenList",
          "params": {
	          "cameraInfo":[
          ]
        },
          "token": "#",
          "id": 0
    },
        GetalarmPointName:{
          "version": 1,
          "method": "alarmpoint.GetPointNameList",
          "params": {
            "pointName":"",
          },
          "token": "#",
          "id":0
        },
        alarmPointName:[],
        getAreaList:{
          "version": 1,
          "method": "area.GetAreaList",
          "params": null,
          "token": "#",
          "id": 0
    },
        getAccess:{
          "version": 1,
          "method": "camera.GetAccessToken",
          "params": {},
          "token": "#",
          "id": 0
        },
        accessToken:'',
        areaList:[],
        IdAndLocationList:[],
        previewURLList:[],
        dataList:{
          appKey:"",
          appSecret:""
        }
      }
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },
    methods:{
      filterNode (value, data, node) {
        if (!value) return true
        let parentNode = node.parent,
          labels = [node.label],
          level = 1
        while (level < node.level) {
          labels = [...labels, parentNode.label]
          parentNode = parentNode.parent
          level++
        }
        return labels.some(label => label.indexOf(value) !== -1)
      },
      getCheckedNodes() {
        let array = [];
        let index = 0;
        for(let i=0;i<this.$refs.tree.getCheckedNodes(true).length;i++){
          if(this.$refs.tree.getCheckedNodes(true)[i] !=null){
            index++;
            array.push(this.$refs.tree.getCheckedNodes(true)[i])
          }
        }
        // for(let i=0;i<array.length;i++){
        //   alert("1:"+array[i])
        // }
        if(index>this.camWin*this.camWin){
          alert("所选摄像头过多，当前"+array.length+"个")
        }
        if(index<=this.camWin*this.camWin){
          if(this.camWin==1){
            document.getElementById('video-container').innerHTML = '';
          }
          if(this.camWin==2){
            document.getElementById('video-container11').innerHTML = "";
            document.getElementById('video-container12').innerHTML = "";
            document.getElementById('video-container13').innerHTML = "";
            document.getElementById('video-container14').innerHTML = "";
          }
          if(this.camWin==3){
            document.getElementById('video-container1').innerHTML = "";
            document.getElementById('video-container2').innerHTML = "";
            document.getElementById('video-container3').innerHTML = "";
            document.getElementById('video-container4').innerHTML = "";
            document.getElementById('video-container5').innerHTML = "";
            document.getElementById('video-container6').innerHTML = "";
            document.getElementById('video-container7').innerHTML = "";
            document.getElementById('video-container8').innerHTML = "";
            document.getElementById('video-container9').innerHTML = "";
          }
          //document.getElementById('video-container').innerHTML = "";

          let array1 = [];
          // for(let i=0;i<array.length;i++){
          //   alert("2:"+array[i])
          // }
          let idAndLocalArray = [];
          let authAndID = [];
          let j = 0;
          for(let i=0;i<this.$refs.tree.getCheckedNodes(true).length;i++){
            if(this.$refs.tree.getCheckedNodes(true)[i] !=null){
              array1[j] = this.$refs.tree.getCheckedNodes(true)[i];
              j++;
            }
          }
          //alert(array1.toString())
          for(let i=0;i<array1.length;i++){
            let treeArray= new Object();
            treeArray.alarmPointId = array1[i].id.substring(0,array1[i].id.indexOf("+"));
            treeArray.location = parseInt(array1[i].id.charAt(array1[i].id.indexOf("+")+1));
            idAndLocalArray[i] = treeArray;
          }

          this.getPreviewURL.params.cameraInfo = idAndLocalArray;
          this.$axios.post('https://open.ys7.com/api/lapp/token/get',this.$qs.stringify(this.dataList)).then(res=>{
            this.accessToken = res.data.data.accessToken
          })

          this.$axios.post(this.$mainUrl,this.getPreviewURL).then(res=>{
            if(res.data.hasOwnProperty('result')){
              //this.pointName = [];
              let pointName =['警报点名称','警报点名称','警报点名称','警报点名称','警报点名称','警报点名称','警报点名称','警报点名称','警报点名称'];
              for(let i=0;i<res.data.result.ezopenList.length;i++){
                if(res.data.result.ezopenList[i].location == 1){
                  pointName[i] = res.data.result.ezopenList[i].pointName+"-室内"
                }else{
                  pointName[i] = res.data.result.ezopenList[i].pointName+"-室外"
                }
                //pointName[i] = res.data.result.ezopenList[i].pointName
                let arr = new Object();
                if(this.radio == '1'){
                  arr.previewHd = res.data.result.ezopenList[i].previewFl;
                }
                if(this.radio == '2'){
                  arr.previewHd = res.data.result.ezopenList[i].previewHd;
                }
                if(res.data.result.ezopenList[i].authCode == ''||res.data.result.ezopenList[i].authCode ==null){
                  arr.authCode = '';
                }else{
                  arr.authCode = res.data.result.ezopenList[i].authCode+'@'
                }
                authAndID[i] = arr;
              }
              let _this = this;
              let preURL = [];
              for(let i=1;i<=authAndID.length;i++){
                let URL = ''
                let str = authAndID[i-1].previewHd.indexOf('/')
                let result1 = authAndID[i-1].previewHd.substr(0,str+1);
                let result2 = authAndID[i-1].previewHd.substr(str + 2,authAndID[i-1].previewHd.length-str-1);
                URL = result1+'/'+authAndID[i-1].authCode+result2;
                preURL.push(URL);
              }
              if(this.camWin==1){
                this.pointName = pointName;
                for(let i=1;i<=preURL.length;i++){
                  setTimeout(function () {
                    let player1 = new EZUIKit.EZUIKitPlayer({
                      id: 'video-container', // 视频容器ID
                      accessToken: _this.accessToken,
                      url:preURL[i-1]
                      //url: preURL.toString(),
                    });
                    // let player2 = new EZUIKit.EZUIKitPlayer({
                    //   id: 'video-container2', // 视频容器ID
                    //   accessToken: _this.accessToken,
                    //   url: preURL[1],
                    // });
                    // player2.stop()
                    // player2.play()
                  },1000);
                }
              }
              if(this.camWin==2){
                this.pointName = pointName;
                for(let i=1;i<=preURL.length;i++){
                  setTimeout(function () {
                    let player1 = new EZUIKit.EZUIKitPlayer({
                      id: 'video-container1'+i, // 视频容器ID
                      accessToken: _this.accessToken,
                      url:preURL[i-1]
                      //url: preURL.toString(),
                    });
                    // let player2 = new EZUIKit.EZUIKitPlayer({
                    //   id: 'video-container2', // 视频容器ID
                    //   accessToken: _this.accessToken,
                    //   url: preURL[1],
                    // });
                    // player2.stop()
                    // player2.play()
                  },1000);
                }
              }
              if(this.camWin==3){
                this.pointName = pointName;
                for(let i=1;i<=preURL.length;i++){
                  setTimeout(function () {
                    let player1 = new EZUIKit.EZUIKitPlayer({
                      id: 'video-container'+i, // 视频容器ID
                      accessToken: _this.accessToken,
                      url:preURL[i-1]
                      //url: preURL.toString(),
                    });
                    // let player2 = new EZUIKit.EZUIKitPlayer({
                    //   id: 'video-container2', // 视频容器ID
                    //   accessToken: _this.accessToken,
                    //   url: preURL[1],
                    // });
                    // player2.stop()
                    // player2.play()
                  },1000);
                }
              }




              // setTimeout(function () {
              //       let player = new EZUIKit.EZUIKitPlayer({
              //         id: 'video-container', // 视频容器ID
              //         accessToken: _this.accessToken,
              //         url: preURL.toString(),
              //         splitBasis: parseInt(_this.cameraWin)
              //       })
              //     },2000)


              // let a = function(index,url){
              //   this.$nextTick(()=>{
              //     let player = new EZUIKit.EZUIKitPlayer({
              //       id: 'video-container'+index, // 视频容器ID
              //       accessToken: _this.accessToken,
              //       url: url,
              //     })
              //   })
              //
              // }


              // for(let i=1;i<=preURL.length;i++){
              //   // a(i,preURL[i-1])
              //   (function (j) {
              //     // setTimeout(function () {
              //        new EZUIKit.EZUIKitPlayer({
              //         id: 'video-container'+j, // 视频容器ID
              //         accessToken: _this.accessToken,
              //         url: preURL[j-1],
              //       })
              //     // },1000)
              //   })(i)
              // }


              // for(let i=1;i<=authAndID.length;i++){
              //   (function(i){
              //     setTimeout(function () {
              //       let URL = ''
              //       let str = authAndID[i-1].previewHd.indexOf('/')
              //       let result1 = authAndID[i-1].previewHd.substr(0,str+1);
              //       let result2 = authAndID[i-1].previewHd.substr(str + 2,authAndID[i-1].previewHd.length-str-1);
              //       URL = result1+'/'+authAndID[i-1].authCode+result2;
              //       let player = new EZUIKit.EZUIKitPlayer({
              //         id: 'video-container'+i, // 视频容器ID
              //         accessToken: _this.accessToken,
              //         url: URL,
              //       })
              //     },1000)
              //   })(i)
              //
              // }
            }
          })


          //this.IdAndLocationList = idAndLocalArray;
          //  let previewURLList1 = []
          // for(let i=0;i<idAndLocalArray.length;i++){
          //   this.getPreviewURL.params.alarmPointId = idAndLocalArray[i].alarmPointId
          //   this.getPreviewURL.params.location = parseInt(idAndLocalArray[i].location)
          //   this.$axios.post(this.$mainUrl,this.getPreviewURL).then(res=>{
          //     if(res.data.hasOwnProperty('result')){
          //       alert(this.getPreviewURL.params.location)
          //       previewURLList1[i] = res.data.result.ezopenList[0].previewHd;
          //     }
          //   })
          //   this.previewURLList=previewURLList1
          //
          // }
          // let array = this.previewURLList

        }


      },
      getAccessToken(){
        this.$axios.post(this.$mainUrl,this.getAccess).then(res=>{
          if(res.data.hasOwnProperty('result')){
            this.dataList.appKey = res.data.result.appKey;
            this.dataList.appSecret = res.data.result.appSecret;
          }
        })
      },

      getAlarmPointNameAndArea(){
        for (let key in this.GetalarmPointName.params) {
          if (this.GetalarmPointName.params[key] === "") {
            this.GetalarmPointName.params[key] = null;
          }
        };
        this.$axios.post(this.$mainUrl,this.GetalarmPointName).then(res=>{
          if(res.data.hasOwnProperty('result')){
            this.alarmPointName = res.data.result.pointNameList;
            let treeArray1=[];
            this.$axios.post(this.$mainUrl,this.getAreaList).then(res=>{
              if(res.data.hasOwnProperty('result')){
                this.areaList = res.data.result.areaList;
                for(let i=0;i<res.data.result.areaList.length;i++) {
                  let treeArray= new Object();
                  treeArray.areaId = res.data.result.areaList[i].areaId;
                  treeArray.label = res.data.result.areaList[i].areaName;
                  treeArray.children = [];
                  treeArray1.push(treeArray);
                }

                for(let i=0;i<this.alarmPointName.length;i++){
                  for(let j=0;j<treeArray1.length;j++){
                    if(treeArray1[j].areaId==this.alarmPointName[i].areaId.substring(0,2)){
                      let treeArray= new Object();
                      treeArray._id = this.alarmPointName[i]._id;
                      treeArray.label = this.alarmPointName[i].pointName;
                      treeArray.children = [{id:this.alarmPointName[i]._id+"+1",label:"室内"},{id:this.alarmPointName[i]._id+"+2",label:"室外"}]
                      treeArray1[j].children.push(treeArray);
                    }
                  }
                }
                this.treeDate = treeArray1
              }
            })
          }
        })

      },
      reset(){
        this.pointName = ['警报点名称','警报点名称','警报点名称','警报点名称','警报点名称','警报点名称','警报点名称','警报点名称','警报点名称']
          if(this.camWin==1){
            document.getElementById('video-container').innerHTML = '';
          }
          if(this.camWin==2){
            document.getElementById('video-container11').innerHTML = "";
            document.getElementById('video-container12').innerHTML = "";
            document.getElementById('video-container13').innerHTML = "";
            document.getElementById('video-container14').innerHTML = "";
          }
          if(this.camWin==3){
            document.getElementById('video-container').innerHTML = '';
            document.getElementById('video-container1').innerHTML = "";
            document.getElementById('video-container2').innerHTML = "";
            document.getElementById('video-container3').innerHTML = "";
            document.getElementById('video-container4').innerHTML = "";
            document.getElementById('video-container5').innerHTML = "";
            document.getElementById('video-container6').innerHTML = "";
            document.getElementById('video-container7').innerHTML = "";
            document.getElementById('video-container8').innerHTML = "";
            document.getElementById('video-container9').innerHTML = "";
          }

      },


      changePlayBackStu(){
        this.isPlayBack = true;
      },
    },
    mounted: function() {
      this.getAccessToken()
      this.getAlarmPointNameAndArea()
    },
    destroyed () {
      this.stop()
    }
  }
</script>

<style scoped>

</style>
